import { Language, languages, Locale } from "../../Utils";
import i18next from "../../i18next";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../../Hooks/useStore";
import { getCurrentLanguageFromUrl, updateUrlWithLanguage } from "../../Utils/urlLanguageUtils";

export const initializeLanguage = () => {
  const urlLanguage = getCurrentLanguageFromUrl();
  const localStorageLanguage = localStorage.getItem("i18nextLng") as Locale;

  const initialLanguage =
      urlLanguage ||
      (localStorageLanguage && languages[localStorageLanguage] ? localStorageLanguage : "fa");

  if (urlLanguage) {
    localStorage.setItem("i18nextLng", urlLanguage);
  }

  // @ts-ignore
  if (i18next.isInitialized) {
    // @ts-ignore
    i18next.changeLanguage(initialLanguage);
  } else {
    // @ts-ignore
    i18next.on("initialized", () => {
      // @ts-ignore
      i18next.changeLanguage(initialLanguage);
    });
  }

  return {
    ...languages[initialLanguage],
    isChanging: false,
  };
};

export const languageInitialState = initializeLanguage();

export const languageSlice = createSlice({
  name: "language",
  reducers: {
    changeLanguage: (state, action: PayloadAction<Locale>) => {
      localStorage.setItem("i18nextLng", action.payload);
      updateUrlWithLanguage(action.payload);
    },
    setLanguage: (state, action: PayloadAction<Locale>) => {
      state.name = languages[action.payload].name;
      state.locale = languages[action.payload].locale;
      state.direction = languages[action.payload].direction;
      // @ts-ignore
      i18next.changeLanguage(action.payload);
    },
    syncWithUrl: (state) => {
      const urlLanguage = getCurrentLanguageFromUrl();

      if (urlLanguage && urlLanguage !== state.locale) {
        state.name = languages[urlLanguage].name;
        state.locale = languages[urlLanguage].locale;
        state.direction = languages[urlLanguage].direction;

        localStorage.setItem("i18nextLng", urlLanguage);
        // @ts-ignore
        i18next.changeLanguage(urlLanguage);
      }
    },
  },
  initialState: languageInitialState,
});

export const useLanguage = () => {
  return useAppSelector((state) => state.language);
};

export const { changeLanguage, setLanguage, syncWithUrl } = languageSlice.actions;
export default languageSlice.reducer;
